import { Navigate, Outlet, redirect, useLocation, type LoaderFunctionArgs } from "react-router";
import { useAccount } from "../../app/session";
import { BetriebFaktorPflicht } from "../../app/ZweiterFaktor";
import { StartLaden } from "../../components/Ladeschirm";
import { ErrorState } from "../../components/States";
import { ZweiFaktorVerwalten } from "../../components/ZweiFaktor";
import { betriebZuIntern, INTERN_ANMELDEN } from "../../lib/bereich";

/**
 * Zugangstor des internen Bereichs (/intern, Inhaber 03.11.2026). Ohne interne Sitzung zur internen Anmeldung; ein Konto
 * außerhalb des Teams ebenso, dort wird nur die interne Sitzung beendet und neutral gemeldet (pages/intern/Anmelden.tsx).
 * Admin und Vertrieb (0459); welche Seiten und Knöpfe, entscheidet die Rolle, jede Abfrage prüft die Datenbank selbst.
 */
export function InternArea() {
  const { session, account, loading, error } = useAccount();
  const location = useLocation();
  if (loading) return <StartLaden />;
  const anmelden = `${INTERN_ANMELDEN}?weiter=${encodeURIComponent(location.pathname + location.search)}`;
  if (!session) return <Navigate to={anmelden} replace />;
  if (error || !account) return <ErrorState error={error ?? new Error("Der Zugang konnte nicht geladen werden.")} />;
  if (!account.isPlatformStaff) return <Navigate to={anmelden} replace />;
  return <BetriebFaktorPflicht pflicht={account.platformMfaRequired}><Outlet /></BetriebFaktorPflicht>;
}

/** Alte Adressen /betrieb und /betrieb/… (Lesezeichen, Dock-App, Mails) dauerhaft nach /intern/…, schon vor dem Zeichnen */
export function betriebUmleitungLoader({ request }: LoaderFunctionArgs): Response {
  const u = new URL(request.url);
  return redirect(`${betriebZuIntern(u.pathname)}${u.search}`);
}
/** Rückfall ohne Loader (Anker im Pfad bleibt erhalten) */
export function BetriebUmleitung() {
  const { pathname, search, hash } = useLocation();
  return <Navigate to={`${betriebZuIntern(pathname)}${search}${hash}`} replace />;
}

/** Anmeldung & Sicherheit der internen Sitzung: zweiter Faktor (Authenticator-App) */
export function InternSicherheit() {
  return (
    <>
      <title>Anmeldung & Sicherheit · Konsole · CreatorOffice</title>
      <div className="pagehead"><div><h1>Anmeldung & Sicherheit</h1><p className="muted">Zweiter Faktor für die interne Anmeldung. Die Konsole öffnet nur mit ihm.</p></div></div>
      <ZweiFaktorVerwalten lang="de" headingId="intern-zwei-faktor" />
    </>
  );
}
